export const relativeDateRegex = /^[0-9]*[yMwdHhms]$/;
export const handlesbarsRegex = /{{.*}}/;
const esDateRegex = /(\d{4}-[01]\d-[0-3]\d)[\sT]*([0-2]\d:[0-5]\d:[0-5]\d)/;

// returns true if there is an error
export const validateRelativeDate = (relDateStr: string) => {
  if (relDateStr) {
    return !relDateStr.split('/').every((term) =>
      term.split(/[-+]/).every((token) => {
        // if token contains handlebars just pass it through
        if (token.includes('{{')) {
          return token.match(handlesbarsRegex);
        }
        switch (token) {
          case 'now':
            return true;
          default:
            return token.match(relativeDateRegex);
        }
      }),
    );
  }
  return true;
};

// epoch (or negative epoch)
export const epochTimeRegex = /^[-]?\d+$/;

// returns true if epoch date
// checks that all values in string are numbers, and therefore a valid epoch date
export const isEpochDate = (date: string) => {
  return !!date.match(epochTimeRegex);
};

// returns true if the string is a parsable date
export const isDateString = (date: string) => {
  return !isNaN(Date.parse(date));
};

// returns true if date matches ES_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const isEsDateString = (date: string) => {
  return !!date.match(esDateRegex);
};

// Validates date, checking if it is an epoch date or relative date
// returns true if there is an error
export const validateDate = (date: string) => {
  if (!date) {
    return true;
  }

  if (isEpochDate(date)) {
    return false;
  }

  if (isDateString(date)) {
    return false;
  }

  return validateRelativeDate(date);
};
